import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ListViewIcon, DateIcon } from 'foundations-assets';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { useRawParamsForListRolloutProductUpdates } from '../hooks/useRawParamsForListRolloutProductUpdates';
import I18n from 'I18n';
import { ScheduledUpdatesViews } from '../constants';
import { TrackingAction, TrackingFeature, TrackingScreen, TrackingSubscreen, trackUsage } from '../../app/utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductUpdatesScheduledCalendarToggle = () => {
  const setQueryParams = useSetQueryParams();
  const {
    view
  } = useRawParamsForListRolloutProductUpdates();
  const handleViewChange = newView => {
    const queryParams = {
      view: newView,
      calendarTimestamp: '',
      limit: '',
      offset: ''
    };
    if (newView === ScheduledUpdatesViews.CALENDAR) {
      setQueryParams(Object.assign({}, queryParams, {
        calendarTimestamp: String(I18n.moment().valueOf())
      }));
      trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.SCHEDULED_FOR_RELEASE_CALENDAR, TrackingFeature.SCHEDULED_FOR_RELEASE_VIEW, TrackingAction.CLICK);
    }
    if (newView === ScheduledUpdatesViews.TABLE) {
      setQueryParams(queryParams);
      trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.SCHEDULED_FOR_RELEASE_TABLE, TrackingFeature.SCHEDULED_FOR_RELEASE_VIEW, TrackingAction.CLICK);
    }
  };
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(IconButton, {
      active: view === ScheduledUpdatesViews.TABLE,
      onClick: () => handleViewChange(ScheduledUpdatesViews.TABLE),
      children: /*#__PURE__*/_jsx(ListViewIcon, {})
    }), /*#__PURE__*/_jsx(IconButton, {
      active: view === ScheduledUpdatesViews.CALENDAR,
      onClick: () => handleViewChange(ScheduledUpdatesViews.CALENDAR),
      children: /*#__PURE__*/_jsx(DateIcon, {})
    })]
  });
};
export default ProductUpdatesScheduledCalendarToggle;